<section class="modal-dialog modal-content overlay-def">
  <header class="modal-header">
    <h2 class="modal-title" id="lbx-title">{{'modal_deployment_timeout.title' | translate }}</h2>
  </header>
  <div class="modal-body">
    <div >
      <p [innerHtml]="'modal_deployment_timeout.maintenance_message' | translate: { minutes: remainingTime.minutes, seconds: remainingTime.seconds } " >
      </p>
   </div>
  </div>
  <div class="modal-footer">
    <ng-container>
      <div class="row no-margin">
        <div class="col-sm-12 col-md-offset-8 col-md-4 mrgn-tp-md">
          <carm-button id="startagainBtn" btnLabel="{{'modal_deployment_timeout.btn_close' | translate}}" [btnStretch]="true" [btnTypePrimary]="true"
            (click)="closeModal()">
          </carm-button>
        </div>
      </div>
    </ng-container>
  </div>
</section>
